import { createStore } from 'vuex';
import { api } from 'JIX/utils.js';

const getters = {
    currentQuestion(state) {
        return state.questions[0] || {
            left:   "",
            right:  "",
            index: -1,
        };
    },
    questionsRemaining(state) {
        return state.questions.length;
    },
    questionsAnswered(state, getters) {
        return state.questionsSize - getters.questionsRemaining;
    },
    shouldWarnUser(state, getters) {
        return (!state.userWarned &&
            state.dontKnowAnswers / getters.questionsAnswered > 0.33 &&
            getters.questionsAnswered > 8);
    }
};

const mutations = {
    nextQuestion(state) {
        state.questions.shift();
    },
    setWarnModal(state, modal) {
        state.warnModal = modal;
    },
};

const actions = {
    questionResponse({ commit, dispatch, getters, state }, { qindex, response }) {
        return api("POST", "/talenttest/response", {
            qindex,
            response,
        }).then (() => {
            commit('nextQuestion');

            const qNum = qindex < 9 ? `0${qindex + 1}` : qindex + 1;
            if (response === 0) {
                state.dontKnowAnswers++;
                window.jixAnalytics('event', { category: 'talenttest', action: 'click', label: `spring over spm. ${qNum}` });

                if (getters.shouldWarnUser) { dispatch('testWarn'); }
            } else {
                window.jixAnalytics('event', { category: 'talenttest', action: 'click', label: `svar spm. ${qNum}` });
            }


            if (!getters.questionsRemaining) {
                window.jixAnalytics('event', { category: 'talenttest', action: 'click', label: `fuldført` });
                dispatch('testDone');
            }
        });
    },
    testDone() {
        return api("POST", "/talenttest/done")
            .then(({ rid }) => {
                window.location.href = "/talenttest/resultat?rid=" + rid;
            }, () => {
                // Redirect back as we still have unanswered questions
                // This should really not be hit
                window.location.href = "/talenttest/resultat?ongoing=1";
            });
    },
    testWarn({ state }) {
        state.warnModal.show();
        state.userWarned = true;
    }
};

export default (data) => {
    return createStore({
        state() {
            return {
                ...data,
                dontKnowAnswers: 0,
                userWarned: false,
                warnModal: null,
            };
        },
        getters,
        mutations,
        actions,
    });
};
